import React from 'react';
import { KatButton, KatModal } from '@amzn/katal-react';
import { useTranslation } from 'src/utils';
import { useAppDispatch, useAppSelector } from 'src/redux/hooks';
import { AppState } from 'src/redux/store';
import { setRestrictedAction } from 'src/redux/slices/appNotifications';
import { RestrictedActionTypes } from 'src/types/AppNotifications';

const PermissionsModal: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const restrictedAction = useAppSelector(
    ({ appNotifications }: AppState) => appNotifications.restrictedAction,
  );

  const dispatchRestrictedAction = () => dispatch(setRestrictedAction(undefined));

  const permissionMessages = [
    {
      type: RestrictedActionTypes.marketplace,
      title: t('marketplace_permissions_modal_title'),
      content: t('marketplace_permissions_modal_content'),
    },
    {
      type: RestrictedActionTypes.silenced,
      title: t('silenced_permissions_modal_title'),
      content: t('silenced_permissions_modal_content'),
    },
  ];

  const permissionMessage = permissionMessages.find(
    (message) => message.type === restrictedAction,
  );

  return (
    <KatModal
      data-testid="marketplace-permissions-modal"
      title={permissionMessage?.title}
      noCloseIcon
      visible={!!restrictedAction}
      onClose={dispatchRestrictedAction}
    >
      <div>
        {permissionMessage?.content}
      </div>
      <div slot="footer" className="kat-group-horizontal flex w-full flex-row justify-end">
        <KatButton
          data-testid="marketplace-permissions-modal-submit-btn"
          label={t('ok')}
          onClick={dispatchRestrictedAction}
        />
      </div>
    </KatModal>
  );
};

export default PermissionsModal;
